import { Component, Inject, OnInit, Optional } from '@angular/core';
import { AuthService } from '@auth/auth.service';
import { CountryService } from 'src/app/services/country/country.service';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { LanguageService } from 'src/app/services/language/language.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'mpp-not-supported',
  templateUrl: './not-supported.component.html',
  styleUrl: './not-supported.component.scss',
  standalone: false,
})
export class NotSupportedComponent implements OnInit {
  showMobileAppsBanner: boolean = false;
  messageKey: string = 'REGISTRATION-FORM.onboarding_nightowl_not_supported';

  constructor(
    private authService: AuthService,
    public countryService: CountryService,
    private analyticsService: AnalyticsService,
    public languageService: LanguageService,
    private dialogRef: MatDialogRef<NotSupportedComponent>,
    private router: Router,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { messageKey?: string },
  ) {
    this.dialogRef.disableClose = false;
    if (data?.messageKey) {
      this.messageKey = data.messageKey;
    }
  }

  ngOnInit() {
    this.countryService.initializeMobileStoreLinks();
    this.setAppBanner();
    this.dialogRef.backdropClick().subscribe(() => {
      this.closeModal();
    });
  }

  closeModal() {
    this.dialogRef.close();
    if (this.router.url !== '/experience-launcher') {
      this.analyticsService.logLoggedOutEvent();
      this.authService.logout();
    }
  }

  setAppBanner(): void {
    if (this.countryService.latAmNonRollout()) {
      this.showMobileAppsBanner = false;
    } else {
      this.showMobileAppsBanner = true;
    }
  }

  playStoreLinkClicked(): void {
    this.analyticsService.logPlayStoreRedirect(
      this.countryService.getSelectedCountryId(),
      this.analyticsService.redirectLocationVideoCarousel,
    );
  }

  appStoreLinkClicked(): void {
    this.analyticsService.logAppStoreRedirect(
      this.countryService.getSelectedCountryId(),
      this.analyticsService.redirectLocationVideoCarousel,
    );
  }
}
